import type { PartialDictionary } from './en';

/**
 * Polish — scaffold only. Untranslated keys fall back to Ukrainian.
 * Enable in src/i18n/locales.ts once complete.
 */
export const pl: PartialDictionary = {
  meta: { localeName: 'Polski', short: 'PL' },
  common: { next: 'Dalej', back: 'Wstecz', soon: 'wkrótce' },
  hero: { titleA: 'Tworzymy dekor, który', titleAccent: 'sprzedaje', titleB: 'Twój produkt' },
};
